import { render, staticRenderFns } from "./jfrule.vue?vue&type=template&id=5db35760"
import script from "./jfrule.vue?vue&type=script&lang=js"
export * from "./jfrule.vue?vue&type=script&lang=js"
import style0 from "./jfrule.vue?vue&type=style&index=0&id=5db35760&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports